module.exports = __webpack_public_path__ + "static/media/AboAkademi-logo_black.2cfab261.webp";